import React from 'react';
import { MessageCircleIcon, PhoneIcon } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { site } from '../../data/site';
import { buttonStyles } from '../../utils/styles';
export function MobileCallBar() {
  const {
    t
  } = useLanguage();
  return <div className="fixed inset-x-0 bottom-0 z-40 border-t border-mist bg-white px-4 py-3 shadow-[0_-4px_16px_rgba(44,62,80,0.08)] lg:hidden" data-id="element-201" data-mp="1o1qk3jg7bml9">
      <div className="mx-auto grid max-w-lg grid-cols-2 gap-3" data-id="element-202" data-mp="10ceawjkvjeiy">
        <a href={site.tel} className={`${buttonStyles.primary} px-4`} data-id="element-203" data-mp="wasoo7mg9nw3">
          <PhoneIcon className="h-5 w-5" aria-hidden="true" data-id="element-204" data-mp="1aa26tcu7us2p" />
          {t({
          en: 'Call Now',
          es: 'Llamar'
        })}
        </a>
        <a href={site.whatsapp} target="_blank" rel="noopener noreferrer" className={`${buttonStyles.whatsapp} px-4`} data-id="element-205" data-mp="15afud5m7pfuy">
          <MessageCircleIcon className="h-5 w-5" aria-hidden="true" data-id="element-206" data-mp="2lo5zmfp2ia66" />
          WhatsApp
        </a>
      </div>
    </div>;
}